import { useEffect, useState } from "react";
import { getActions } from "app/features/actionsSlice";
import { editGroup, getGroupById, hideToast } from "app/features/groupsSlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import GroupForm from "components/Forms/GroupForm/GroupForm";
import FormCard from "components/Forms/FormCard/FormCard";
import { useParams } from "react-router-dom";
import { Action, Group, Permission } from "types";
import { getToastMessage } from "lib/helpers/toastMessageHelper";
import NewToast from "ui/atoms/NewToast";
import withAuth from "lib/hoc/withAuth";

const GroupEdit = () => {
  const param = useParams();
  const dispatch = useAppDispatch();
  const groupId = param.groupId ?? "";
  const [selectedActions, setSelectedActions] = useState<Action[] | undefined>([]);

  const { currentGroup, response, severity, error, loading, showToast } = useAppSelector((state) => state.groups);

  useEffect(() => {
    dispatch(getGroupById(groupId));
    dispatch(getActions());
  }, []);

  useEffect(() => {
    const data: Action[] | undefined = currentGroup?.permissions?.map((p: Permission) => {
      const action: Action = {
        actionID: p.actionID,
        description: p.actionDescription,
        moduleID: "",
        menuRoute: "",
        menuOption: "",
      };
      return action;
    });
    setSelectedActions(data);
  }, [currentGroup]);

  const actions = useAppSelector((state) => state.actions.actions);

  const onUpdateGroup = async (group: Group) => {
    await dispatch(editGroup(group));
  };

  const onCloseToast = () => {
    dispatch(hideToast());
  };

  return (
    <>
      <NewToast open={showToast} setOpen={onCloseToast} severity={severity}>
        {getToastMessage(response, error)}
      </NewToast>
      <FormCard maxWidthCard={775} maxWidthContainer='md' title='Edición de Grupos'>
        <GroupForm
          actions={actions}
          loading={loading}
          group={currentGroup}
          handleSubmit={onUpdateGroup}
          submitButtonText='Editar Grupo'
          selectedActions={selectedActions}
          setSelectedActions={setSelectedActions}
        />
      </FormCard>
    </>
  );
};

export default withAuth(GroupEdit);
